<template>
  <div class="users-out">
    <CDNTabs :tabs="tabs" />
    <div class="users-manage">
      <div class="menu-title">
        <div class="menu-right">
          <div class="filter-container" @click="filterClick">
            <CDNButton
              :BtnText="$t('common.filter')"
              :hasBg="isFilter"
              :imgPath="require('@/assets/images/products/icon_filter.png')"
            />
            <CDNButton
              :hasBg="isFilter"
              :imgPath="require('@/assets/images/products/icon_down.png')"
              innerstyle="margin-left: 5px;"
            />
          </div>
        </div>
      </div>
      <div v-show="isFilter" class="input-container">
        <loginInput
          :label="$t('AttackWarn.domain')"
          :appendIcon="require('@/assets/images/domain/icon_domain.png')"
          inputStyle="width: 288px;"
          realInputStyle="width: 288px;"
          @changeInput="(e) => (searchDomain = e)"
          :inputValue="searchDomain"
        />
      </div>

      <div class="search-btn-content" v-show="isFilter">
        <CDNButton
          :hasBg="true"
          :imgPath="require('@/assets/images/products/prod_icon_search.png')"
          innerstyle="padding: 6px 20px;"
          :BtnText="$t('common.search')"
          @btnclick="searchClick"
        />
        <CDNButton
          :imgPath="require('@/assets/images/products/prod_icon_reset.png')"
          innerstyle="margin-left: 20px;padding: 6px 20px;"
          :BtnText="$t('common.reset')"
          @btnclick="resetClick"
        />
      </div>

      <!-- 列表 -->
      <el-table :data="tableData" height="500" style="width: 100%">
        <el-table-column
          align="center"
          prop="fromHost"
          :label="$t('AttackWarn.domain')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="attackType"
          :label="$t('AttackWarn.type')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="attackCount"
          width="100"
          :label="$t('AttackWarn.attackCount')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="spamIp"
          :label="$t('AttackWarn.originIp')"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="message"
          show-overflow-tooltip
          :label="$t('AttackWarn.remark')"
          width="120"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="time"
          :label="$t('AttackWarn.date')"
        >
        </el-table-column>
      </el-table>
      <!--  -->
      <div class="pagination-bottom">
        <Pagination
          :total="total"
          :page-size="pageSize"
          :page-count="pageCount"
          @change="handleChange"
        />
      </div>
      <!-- 列表 -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { hitYJ } from "@/service/requestRes";

export default {
  data() {
    return {
      isFilter: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      pageCount: 1,
      selectItems: [],
      searchDomain: "",
    };
  },
  computed: {
    tabs() {
      return [this.$t("AttackWarn.Attackwarn")];
    },
  },
  mounted() {
    this.getAttackList({ page: 1 });
  },
  methods: {
    getAttackList({ page, start_date, end_date, host }) {
      hitYJ({ page, start_date, end_date, host, limit: this.pageSize }).then(
        (res) => {
          const { data, code, msg } = res || {};
          if (code === 1) {
            const { list } = data || {};
            const { total } = list || {};
            this.total = total;
            this.tableData = list.data;
          } else {
            this.$message({
              message: msg,
              type: "error",
            });
          }
        }
      );
    },
    handleChange(e) {
      this.getAttackList({ page: e });
    },
    filterClick() {
      this.isFilter = !this.isFilter;
    },
    searchClick() {
      this.getAttackList({ page: 1, host: this.searchDomain });
    },
    resetClick() {
      this.searchDomain = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.users-out {
  width: 1276px;
  margin: 24px auto;
}
.users-manage {
  background-color: white;
  padding: 0 24px 24px 24px;
  border-radius: 4px;
  .menu-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    span {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5a607f;
    }
    .menu-right {
      height: 60px;
      display: flex;
      align-items: center;
    }
  }
  .filter-container {
    display: flex;
    align-items: center;
  }
  .input-container {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }
  .search-btn-content {
    display: flex;
    margin-bottom: 49px;
  }
  .user-handle {
    display: flex;
    align-items: center;
    :first-child {
      margin-right: 10px;
      width: 16px;
      height: 16px;
    }
    :last-child {
      width: 18px;
      height: 19px;
    }
  }
}
</style>
